import { page } from '$app/stores';
import { loadingRaces } from '$components/race/RaceList.svelte';
import { selectedRaceId } from '$utils/navigation';
import { derived, get } from 'svelte/store';

export const selectedRace = derived([selectedRaceId, page], ([id, page]) => {
  if (!page?.data?.race || !page?.data?.races) return null;
  const pageRace = get(page.data.race);
  const pageRaces = get(page.data.races);
  if (id === pageRace?.id) {
    loadingRaces.set(false);
    return pageRace;
  }

  return pageRaces?.data?.races.find((r) => {
    return r.id === id;
  });
});
